import React, { SVGProps } from 'react';

interface ChartIconProps extends SVGProps<SVGSVGElement> {
	color?: string;
}

function ChartIcon({ color, ...props }: ChartIconProps) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.85 8.8499L0.15 8.1499L5.5 2.7899L8.5 5.7899L14.15 0.149902L14.85 0.849902L8.5 7.2099L5.5 4.2099L0.85 8.8499ZM12 5.9999H15V15.9999H12V5.9999ZM3 11.9999H0V15.9999H3V11.9999ZM11 8.9999H8V15.9999H11V8.9999ZM4 7.9999H7V15.9999H4V7.9999Z"
				fill={color || '#808080'}
			/>
		</svg>
	);
}

export default ChartIcon;
